/* eslint-disable no-redeclare */
import { z } from 'zod';

export const IpAddress = z.string().ip();

export type IpAddress = z.infer<typeof IpAddress>;
